import { User } from "../../actiontracker/model/user.model";
import { IncidentRating } from '../../incident/model/incident-rating';

export class DashboardFilter {
	OrderdByColoumName: string;
	OrderdBy: string;
	PageSize: number;
	PageIndex: number;
	InputParams: Parms = new Parms();
	IncidentFromDate: Date;
	IncidentToDate: Date;
	StatusId: number[] = [];
	RaisedBy: number;
	IncidentType: string[];
	CaseOwnerId: number;
	CompanyId: number;
	Status: number;
	CurrentPage: any;
	UserId: number;
	UnitId: number;
	Locations: number[] = [];
	CheckinLocations: number[] = [];
	HighPotential: number[];
	SearchText: string = '';
	CaseOwner: User;
	Companies: number[] = [];
	MonitoringMatrixFilter: number[] = [];
  SectionFilter: number[] = [];
	Units: number[] = [];
	RecurrencePeriod: string;
	RecurrenceType: string = '0';
	FromDate: Date = new Date();
	ToDate: Date = new Date();
	CheckLists: number[] = [];
	SelectAll: boolean;
	IncidentRating: IncidentRating;
	ReportedTo: string[];
	PassType: number[];
}
export class Parms {
	StatusId: number[] = [];
	RaisedBy: number;
	IncidentType: number;
	CaseOwnerId: number;
	CompanyId: number;
	Status: number;
}
